import { call, put, takeLatest } from "redux-saga/effects";
import { onRegisterUser, onRegisterUserError, onRegisterUserSuccess } from "../Store/Slices/registerSlice";
import { callRegisterUserApi } from "../Context/registerApi";
import { onsaveuserData } from "../Store/Slices/utilitySlice";
function* RegisterUser({payload}) {
  try {
    const registerUserResponse = yield call(callRegisterUserApi, payload);
    if (registerUserResponse.httpStatusCode === "201" || registerUserResponse.httpStatusCode === 201) {
      yield put(
        onRegisterUserSuccess({ 
          data: registerUserResponse.data,
          message: registerUserResponse.message,
          status_code: registerUserResponse.httpStatusCode
        })
      );
      yield put(onsaveuserData({userData: registerUserResponse.data}));
    } else {
      yield put(
        onRegisterUserError({
          data: registerUserResponse.data || null,
          message: registerUserResponse.message || "Registration failed",
          status_code: registerUserResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    yield put(onRegisterUserError({ data: null, message, status_code: 400 }));
  }
}

  
export default function* registerSaga() {
  yield takeLatest(onRegisterUser.type, RegisterUser);
}
